/* eslint-disable react/jsx-filename-extension */
import Card from './Card';

function Podcast({ adNode, pid, altTitle, title, genre, imageSrc, imageSrcset, url, extraText }) {
    return (
        <a
            ref={adNode}
            data-pid={pid}
            href={url}
            className="group py-4 border-b border-gray flex justify-center items-center flex-row flex-1"
        >
            <Card altTitle={altTitle} imageSrc={imageSrc} imageSrcset={imageSrcset} />
            <div className="flex-1 self-start mt-4 lg:mt-6">
                {extraText ? (
                    <h2 className="text-xs sm:text-sm lg:text-base uppercase mb-1 font-semibold text-brand-400">
                        {extraText}
                    </h2>
                ) : null}
                <h2 className="text-black font-medium lg:text-md">{title}</h2>
                <div className="text-gray-600 mt-2 text-xs sm:text-sm lg:text-base">{genre}</div>
            </div>
            <div className="media-block__go">
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#aaaaaa" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </svg>
            </div>
        </a>
    );
}
export default Podcast;
